<script setup>
import { computed, inject } from 'vue'
import { ApiService } from '@/js/services/api'

const props = defineProps(['book'])
const model = defineModel()
const emit = defineEmits(['update'])
const dataset = inject('dataset')

const carti = computed(() => [...props.book.carti])

const postReservation = async (book, event) => {
  if (!dataset.user) {
    document.forms.auth.action += '&next=' + window.location.href
    document.forms.auth.submit()
    return
  }

  const btn = event.target
  btn.classList.add('is-loading')

  try {
    const result = await ApiService.postReservation({ carte: book.id })

    if (result.data_limita_ridicare) {
      Object.assign(book, {
        status: {
          ...result,
          rezervare_proprie: true,
        },
      })
    }

    emit('update')
  } finally {
    btn.classList.remove('is-loading')
  }
}

const deleteReservation = async (reservation, event) => {
  const btn = event.target
  btn.classList.add('is-loading')

  try {
    await ApiService.deleteReservation(reservation.status.id)

    Object.assign(reservation, {
      status: {
        rezervare_proprie: true,
        status: 'Disponibilă',
      },
    })

    emit('update')
  } finally {
    btn.classList.remove('is-loading')
  }
}
</script>

<template>
  <b-modal v-model="model" v-bind="{ 'has-modal-card': true, scroll: 'keep' }">
    <div class="modal-card">
      <header class="modal-card-head">
        <div class="is-flex-grow-1">
          <h1 class="is-size-3 has-text-weight-semibold mb-2">
            {{ book.titlu }}
          </h1>
          <p class="is-size-6 mb-2">de {{ book.autori_str }}</p>
          <p class="is-size-7 has-text-grey">{{ book.domeniu }}</p>
        </div>
      </header>

      <section class="modal-card-body">
        <b-table :data="carti" :show-header="false" striped>
          <b-table-column custom-key="index" width="70" v-slot="props">
            {{ props.index + 1 }}
          </b-table-column>

          <b-table-column custom-key="editura" v-slot="props">
            Editura {{ props.row.editura }}, {{ props.row.loc_aparitie }}
          </b-table-column>

          <b-table-column custom-key="numar_inventar" v-slot="props">
            Nr. inv. {{ props.row.numar_inventar }}, {{ props.row.an_aparitie }}
          </b-table-column>

          <b-table-column
            custom-key="actions"
            v-slot="props"
            cell-class="has-text-right"
          >
          </b-table-column>

          <b-table-column
            custom-key="actions"
            v-slot="props"
            cell-class="has-text-right is-size-7"
          >
            <p
              class="has-text-primary"
              v-if="
                props.row.status.rezervare_proprie &&
                props.row.status.data_limita_ridicare &&
                !props.row.status.predat
              "
            >
              De ridicat până la <br />
              {{ props.row.status.data_limita_ridicare }}
            </p>

            <p
              v-else-if="props.row.status.data_limita_returnare"
              class="has-text-primary"
            >
              Termen de returnare <br />
              {{ props.row.status.data_limita_returnare }}
            </p>

            <p
              class="has-text-danger"
              v-else-if="props.row.status.status != 'Disponibilă'"
            >
              {{ props.row.status.status }}
            </p>
          </b-table-column>

          <b-table-column
            custom-key="actions"
            label=""
            v-slot="props"
            cell-class="has-text-right"
          >
            <button
              type="button"
              class="button is-primary"
              @click="postReservation(props.row, $event)"
              v-if="props.row.status.status == 'Disponibilă'"
            >
              Rezervă
            </button>
            <b-button
              type="is-danger"
              @click="deleteReservation(props.row, $event)"
              v-else-if="
                props.row.status.rezervare_proprie && !props.row.status.predat
              "
            >
              Anulează
            </b-button>
          </b-table-column>
        </b-table>
      </section>
    </div>
  </b-modal>
</template>
